export class FeedData {
    loading: any = !0;
    loadFailed: any = !1;
    multiTenant: any = !1;
    numRetry: any = 0;
    workspaces: any = [];
}
